"use strict";

import Vue from "vue";
import axios from "axios";
import router from "../router"
import store from "../store"
import messageBox from "../components/Global/CMessage/message";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  timeout: 80 * 1000 // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // 需要登录的接口：未登录则直接终止，不发请求
    const isLoggedIn = localStorage.getItem("app_login") == 1;
    if (config.requireAuth && !isLoggedIn) {
      store.dispatch("callLogin");
      return Promise.reject(new Error("未登录，请先登录"));
    }
// Do something before request is sent
    if (config.url.indexOf("/app") === 0) {
      config.baseURL = process.env.VUE_APP_API_URL;
    } else if (config.url.includes("/ibenterprise")) {
      // 公开接口直接使用 env 中的地址
      config.baseURL = process.env.VUE_APP_PUBLIC_API_URL;
      // 已登录才带 token；未登录不传 jwttoken
      if (isLoggedIn) {
        const jwttoken = localStorage.getItem("api_token");
        // 取登录用户信息，任意一步失败都不阻塞业务
        let userInfo = null;
        try {
          userInfo = JSON.parse(localStorage.getItem("userInfo"));
        } catch (e) {
          userInfo = null;
        }
        const enterpriseId =
          userInfo &&
          Array.isArray(userInfo.customerUserEnterpriseVos) &&
          userInfo.customerUserEnterpriseVos[0] &&
          userInfo.customerUserEnterpriseVos[0].enterpriseId;

        if (jwttoken) {
          config.headers.jwttoken = jwttoken;
        } else {
          delete config.headers.jwttoken;
        }
        if (enterpriseId) {
          config.headers.customerenterpriseid = enterpriseId;
        } else {
          delete config.headers.customerenterpriseid;
        }
      } else {
        delete config.headers.jwttoken;
        delete config.headers.customerenterpriseid;
      }
    } else if(config.url.includes("/monitor") || config.url.includes("api/recording")){
      // 录屏接口使用 monitor 的地址
      config.baseURL = process.env.VUE_APP_MONITOR_API_URL;
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    // 登录过期（code === 2）统一跳转登录页
    const resData = response.data;
    if (resData && resData.code === 2) {
      messageBox.error(resData.message || resData.msg || "登录已过期，请重新登录");
      setTimeout(() => {
        store.dispatch("logout").then(() => {
          router.replace({ name: "home" });
          router.go(0);
        });
      }, 1000);
      return Promise.reject(new Error(resData.message || "登录已过期"));
    }
    // 只有 /app/api 开头的接口才检查 code
    if (response.config.url.indexOf("/app/api") > 0) {
      // api 请求 code 不是 200 的都是失败，走 catch 捕捉
      if (response.data.code !== 200) {
        const message = response.data.message || "操作失败";
        if(response.data.code ==4104){
          messageBox.error(response.data.message)
          setTimeout(() => {
            store.dispatch("logout").then(() => {
              router.replace({ name: "home" });
              router.go(0)
            });
          }, 1000);
        }
        throw Error(message);
      }
    }
    if (response.config.url.indexOf("/api/ibenterprise") > 0) {
      // 文件下载（blob）响应直接返回二进制，不校验业务码，避免把成功的文件流误判为失败
      if (response.config.responseType === "blob") {
        return response.data;
      }
      if (response.data.code !== 0) {
        console.log(response);
        const message = response.data.msg || "操作失败";
        // 业务码非 0：界面弹出错误提示，并抛出走 catch
        messageBox.error(message);
        return Promise.reject(new Error(message));
      }
    }
    return response.data;
  },
  function(error) {
    console.log("request error:", error.status);
    const res = JSON.parse(JSON.stringify(error)).response
    if(res.status == 4101||res.status ==4104){
      messageBox.error(response.data.message)
      setTimeout(() => {
        store.dispatch("logout").then(() => {
          router.replace({ name: "home" });
          router.go(0)
        });
      }, 1000);
    }
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default _axios;
